module.exports = __webpack_public_path__ + "media/rick.606d1ff2.mp4";